<template>

  <div>

    <!--<v-dialog v-model="show_dialog_ref" max-width="70%">-->


      <!--<v-card>-->
        <!--<v-card-title>-->
          <!--What is Cancer-->
        <!--</v-card-title>-->
        <!--<v-card-text>-->


          <!--<p>-->
            <!--The U.S. Preventive Services Task Force recommends those 50 - 75 undergo regular screening.-->
            <!--Note, however, that the American Cancer Society recently changed their recommended guidelines to include-->
            <!--those 45 and above.-->
          <!--</p>-->




          <!--Source: US Centers for Disease Control and Prevention (CDC)<br>-->
          <!--<a href="https://www.cdc.gov/cancer/colorectal/basic_info/screening/index.htm"-->
             <!--target="_blank">-->
            <!--https://www.cdc.gov/cancer/colorectal/basic_info/screening/index.htm-->
          <!--</a>-->

          <!--<br>-->
          <!--Source: American Cancer Society <br>-->
          <!--<a href="https://www.cancer.org/cancer/colon-rectal-cancer/detection-diagnosis-staging/acs-recommendations.html"-->
             <!--target="_blank">-->
            <!--https://www.cancer.org/cancer/colon-rectal-cancer/detection-diagnosis-staging/acs-recommendations.html-->
          <!--</a>-->

        <!--</v-card-text>-->

      <!--</v-card>-->


    <!--</v-dialog>-->












    <v-card max-width="900px">
      <v-card-title >
        Colorectal Cancer
      </v-card-title>
      <v-card-text  class="content-text my-content">

        <div class="title">
          What Is It
        </div>
        <!--<img src="@/assets/images/tmp/polyectopy.jpg"  class="floated-image">-->
        <p>

          Cancer is uncontrolled cell growth.  Normally your body regulates how your cells divide and replicate,
          but cancerous cells multiply without this regulation.
          <!--<a href="https://www.cancer.gov/about-cancer/understanding/what-is-cancer" target="_blank">here</a>.-->
            Colorectal cancer is when this growth develops in the colon or rectum.   For more information on cancer in general,
          see [{{getr('nci-whatIs')}}].

        </p>


        <div class="title">
          Symptoms
        </div>

        <p>
          Early stage colorectal cancer has no symptoms, which is why regular screening via a colonoscopy is critical for
          early detection.
        </p>
         <p>
           In later stages, individuals can experience:
         </p>
        <ul>
          <li>Rectal bleeding</li>
          <li>Persistent abdominal pain, cramps, and gas</li>
          <li>Weakness or fatigue </li>
          <li>Unexplained weight loss </li>
          <li>change in the shape, size, and consistency of stool</li>
          <li>A feeling that "everything did not come out"</li>
        </ul>

        <p style="font-style: italic; font-size: 0.9em">
          Note that experiencing these symptoms does not necessarily mean you have cancer, as there are many reasons why you
          might be experiencing them.  However, you should see a doctor for a properly diagnosis should you experience them.
        </p>


        <!--<div class="title">-->
          <!--How Common Is It?-->
        <!--</div>-->
        <!--<p>-->
          <!--According to the National Cancer Institute, there were an estimated 145,000 new cases in 2019.-->
        <!--</p>-->

        <div class="title">
          Causes and Risk Factors
        </div>

        <p>
          The largest risk factor for colorectal cancer is age, as 90% of all cases diagnosed are in individuals above
          the age of 50<sup>[{{getr('gen1')}}]</sup>.
          <!--<span class="ref_object" @click="show_dialog_ref=true">50<sup>[{{getr('gen1')}}]</sup>.</span>-->

          The second most significant factor is family history.  Having a direct relative with colorectal cancer
          nearly doubles the risk of you having it as well<sup>[{{getr('gen1')}}]</sup>.

          <!--<span class="ref_object" @click="show_dialog_ref=true">well<sup>[{{getr('gen1')}}]</sup>.</span>-->
        </p>


        Other factors shown to increase your risk are<sup>[{{getr('factors')}}]</sup>:
        <ul>
          <li>Excessive alcohol use </li>
          <li>Smoking</li>
          <li>Obesity</li>
        </ul>


        <p>
          Race may also be a risk factor<sup>[{{getr('race1')}}, {{getr('race2')}}]</sup>.  One study found that
          African American's risk of developing
          colorectal cancer is about 16% higher when compared to White Americans.  The same study, however, also concluded that
          the observed difference in risks was mostly likely due to behavioral and environmental rather than biological
          differences between races<sup>[{{getr('race3')}}]</sup>.
        </p>




        <div class="title">
          Treatments
        </div>

        <p>
          The overall 5-year survival rate for colorectal cancer is 67%. If diagnosed early, however,
          the survival rate is nearly 90%<sup>[{{getr('survRate')}}]</sup>, hence the importance of early detection.

          When found early,  surgery is the primary treatment option.  For later stages, chemo and radiation therapies
          are also used.
        </p>


        <div class="title">
          When To Call A Doctor
        </div>

        <p>
          Since early stage colorectal cancer has few if any symptoms, early detection is unlikely without proper screenings.
          Hence, talk to your doctor if you're in your mid 40's or older about when would be the right time to start screening
          based on your individual risk profile.
        </p>




        <div class="title">
          References
        </div>
        <refs  :refs="bib"></refs>
      </v-card-text>

    </v-card>
  </div>




</template>






<style scoped lang="scss">
  @use 'contentStyles';

</style>


<script>
// @ is an alias to /src
import refs from '@/components/references.vue';
import utilities from '@/mixins/utilities.js';


export default {
   mixins: [utilities],
   components: {refs},
   data(){return {

      show_dialog_ref: false,
      bib: [
         {
            title: '',
            url: 'https://seer.cancer.gov/statfacts/html/colorect.html',
            date: '',
            org: '',
            ref: 'stats',
         },
         {
            title: '',
            url: 'https://www.cancer.gov/types/colorectal/hp/colorectal-prevention-pdq',
            date: '',
            org: '',
            ref: 'gen1',
         },
         {
            title: '',
            url: 'https://www.ncbi.nlm.nih.gov/pubmed/22514249?dopt=Abstract',
            date: '',
            org: '',
            ref: 'race1',
         },
         {
            title: '',
            url: 'https://www.ncbi.nlm.nih.gov/pubmed/30142339?dopt=Abstract',
            date: '',
            org: '',
            ref: 'race2',
         },

         {
            title: '',
            url: 'https://www.ncbi.nlm.nih.gov/pmc/articles/PMC3784999/',
            date: '',
            org: '',
            ref: 'race3',
         },
         {
            title: '',
            url: 'https://www.cancer.gov/types/colorectal/hp/colorectal-prevention-pdq#_150_toc',
            date: '',
            org: '',
            ref: 'factors',
         },
         {
            title: '',
            url: 'https://www.cancer.gov/about-cancer/understanding/what-is-cancer',
            date: '',
            org: 'National Cancer Institute',
            ref: 'nci-whatIs',
         },
         {
            title: '',
            url: 'https://www.cancer.net/cancer-types/colorectal-cancer/statistics',
            date: '',
            org: '',
            ref: 'survRate',
         }
      ]
   }},



   methods:{
      getr(ref){
         return (this.findWithAttr(this.bib, 'ref', ref)+1).toString();
      }
   },

   created(){
      this.sort_bib_list(this.bib);
   }



}
</script>
